import { useFetcher } from "@remix-run/react"
import { useEffect } from "react"
import type { CustomerAccountLoaderData } from "~/routes/customer-account"

export const useCustomerAccount = () => {
  const fetcher = useFetcher<CustomerAccountLoaderData>()
  useEffect(() => {
    if (fetcher.state === "idle" && !fetcher.data) {
      fetcher.load("/customer-account")
    }
  }, [fetcher])

  const customerAccountData = fetcher.data

  return {
    loggedIn: customerAccountData?.loggedIn,
    customer: customerAccountData?.customer
  }
}
